module.exports = __webpack_public_path__ + "static/todo1.5672ffaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/todo/thumb/todo1.png
// module id = 276
// module chunks = 35783957827783 246384609461072